// components/TermsAndConditions.js


import React from 'react';
import styles from './Term.module.css';

const TermsAndConditions = () => {
  return (
    <section className={styles['terms-section']}>
      <div className={styles['container']}>
        <h2 className={styles['heading']}>Terms and Conditions</h2>
        <p className={styles['paragraph']}>
          By accessing and using MetalZulu, you agree to be bound by the following terms and conditions. Please read them carefully.
        </p>

        <h3 className={styles['subheading']}>1. Acceptance of Terms</h3>
        <p className={styles['paragraph']}>
          By using our services, you agree to comply with and be legally bound by the terms outlined in this agreement.
        </p>

        <h3 className={styles['subheading']}>2. Use of Services</h3>
        <p className={styles['paragraph']}>
          You may use the services only for lawful purposes and in accordance with these terms.
        </p>

        <h3 className={styles['subheading']}>3. Intellectual Property</h3>
        <p className={styles['paragraph']}>
          All content on this site, including text, graphics, logos, and software, is the property of MetalZulu or its licensors.
        </p>

        <h3 className={styles['subheading']}>4. Limitation of Liability</h3>
        <p className={styles['paragraph']}>
          We are not liable for any damages arising from your use of our platform, including but not limited to loss of data or profits.
        </p>

        <h3 className={styles['subheading']}>5. Changes to Terms</h3>
        <p className={styles['paragraph']}>
          We reserve the right to update these terms at any time. Continued use of the platform constitutes acceptance of the new terms.
        </p>
      </div>
    </section>
  );
};

export default TermsAndConditions;
